import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf41de2c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf41de2c&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=bf41de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf41de2c",
  null
  
)

export default component.exports